<template>
    <section class="marquee deposit-tab">
        <div class="container">
            <div class="deposit-outer">
                <div class="fast-bank-deposit b-contant">
                    <div class="back-btn p-al">
                        <a @click="$router.go(-1)" class="back-btn-lef">
                            <img src="@/assets/images/left-arrow-bg.png" alt="" />
                            {{ $t('back', 'Back') }}
                        </a>
                        <span class="bank-deps">{{ $t('bank-details', 'Account Details') }}</span>
                    </div>
                </div>
                <div class="deposit-outer-body b-acc pt-0">
                    <!-- <div class="inner-body pass-form mess-inner bank-acc border-0">
                        <button class="check-bank" type="button">
                            {{ $t('bank', 'Bank') }}
                        </button>
                    </div> -->
                    <div class="inner-body pass-form mess-inner bank-acc border-0" v-if="accountsList && accountsList.length">
                        <div class="sc-lgsldV kHpVxf" v-for="(item, index) in accountsList" :key="index">
                            <div class="sc-bCMXmc kFxBNF">
                                <div class="sc-bCCsHx iPdyVg">
                                    <div class="sc-fJwQoQ kCIPEc" v-if=item?.payment_method_image> 
                                        <img @error="onImageError" :src="item?.awsUrl + item?.payment_method_image"  alt="bank icon">
                                    </div>
                                    <h4>{{ item.method_name ? item.method_name : item.payment_type_name }}</h4>
                                </div>
                                <div class="sc-hdPSEv cAxglY">
                                    <!-- <button @click="goToEdit(item)" class="sc-cmIlrE hRUCxq" type="button">
                                        <div class="sc-ciodno sc-gHpXsY cUyOPs">
                                            <img src="@/assets/images/edi.svg" alt="edit">
                                        </div>
                                        {{ $t('edit', 'Edit') }}
                                    </button> -->
                                    <button @click="selectedRemoveAcc = item; openDeleteModal()" class="sc-gleUXh hXLenv" type="button">
                                        <div class="sc-ciodno sc-gHpXsY cUyOPs">
                                            <img src="@/assets/images/delet.svg" alt="Delete">
                                        </div>
                                        <!-- {{ $t('delete', 'Delete') }} -->
                                    </button>
                                </div>
                            </div>
                            <div class="sc-kxLnmX jGobgJ">
                                <!-- <div class="sc-bCCsHx iPdyVg">{{ item.bank_name ? item.bank_name : item.payment_type_name }}</div> -->
                                <div class="sc-buGlAa iMwaDx">
                                    <div class="sc-flvzOl bmGqtT">
                                        <div class="sc-gOCRIc fzEoVZ">
                                            <span>{{ $t('payment-type', 'Payment Type') }}</span>
                                            <span class="double_dots_width">: </span>
                                            <span>{{ item?.payment_method }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12" @click="copyPaymentData($event,this.$t('payment-type', 'Payment Type'), item?.payment_method)">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>

                                        <div class="sc-gOCRIc fzEoVZ">
                                            <span>{{ $t('name', 'Name') }} </span>
                                            <span class="double_dots_width">:</span>
                                            <span>{{ item?.account_holder_name ? item?.account_holder_name : "" }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12" @click="copyPaymentData($event,this.$t('account-holder-name', 'Account Holder’s Name'), item?.account_holder_name)">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>

                                        <div class="sc-gOCRIc fzEoVZ" v-if="item?.account_number || item?.phone_number"  >
                                            <span>{{ item?.account_number ?  $t('ac-number', 'A/C Number') : $t('phone-number', 'Phone Number') }}</span>
                                            <span class="double_dots_width"> : </span>
                                             <span>{{ item?.account_number ? item?.account_number : item?.phone_number }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12"  @click="copyPaymentData($event,$t('ac-number', 'A/C Number'), item?.account_number)">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>

                                        <div class="sc-gOCRIc fzEoVZ" v-if="item?.payment_method == 'bank' && item?.ifsc_code">
                                            <span>{{ $t('ifsc-code', 'IFSC Code') }}</span>
                                             <span class="double_dots_width">:</span>
                                             <span>{{ item?.ifsc_code }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12"  @click="copyPaymentData( $event, $t('ifsc-code', 'IFSC Code'), item?.ifsc_code )">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>
                                        <div class="sc-gOCRIc fzEoVZ"  v-if="item?.payment_method == 'upi' && item?.upi_id">
                                            <span>{{ $t('upi-id', 'UPI ID') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span>{{ item?.upi_id }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12"  @click="copyPaymentData( $event,$t('upi-id', 'UPI ID') ,  item?.upi_id )">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>
                                        <div class="sc-gOCRIc fzEoVZ"  v-if="item?.payment_method == 'wallet' && item?.crypto_wallet_id">
                                            <span>{{ $t('wallet-id', 'Wallet ID') }}</span>
                                             <span class="double_dots_width">:</span>
                                             <span>{{ item?.crypto_wallet_id }}</span>
                                            <button type="button" class="blinl-messege copy_bank_btn12"  @click="copyPaymentData( $event, $t('wallet-id', 'Wallet ID'), item?.crypto_wallet_id)">
                                                <img src="@/assets/images/copy.png" alt="" />
                                            </button>
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="inner-body pass-form mess-inner bank-acc border-0 p-3  paymentAccount-nodata mt-2" v-else>
                        <span class="text-white">Add Acccount To Withdraw...</span>
                    </div>
                    
                </div>
                
            </div>
            <div class="add_acc_btn_sec">
                <a href="javascript:void(0)" @click="handleAddBankClick" class="add-bank add_bank_btn">+ {{ $t('add-new-bank-account', 'Add New Account') }}</a>
            </div>
        </div>
    </section>

    <div class="modal fade" ref="deleteModalRef" id="deleteModalRef" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <DeletAccountModal v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" :item="selectedRemoveAcc" />
        </div>
    </div>
    <addAccountModal :paymentMethodList="paymentMethodList"></addAccountModal>
</template>

<script>
import DeletAccountModal from '../components/DeletAccountModal.vue';
import addAccountModal from '../components/addAccountModal.vue';
import {getUserAccounts, withdrawWalletAmount, withdrawAmountClickValidation} from '../services/walletWithdraw';
import {openWithdrawPasswordModal} from '../services/withdrawAccountDetails';
import { defineAsyncComponent } from 'vue';
export default {
    name: "BankDetails",
    inject:['walletConfig'],
    data() {
        return {
            loading: false,
            onlyBankStatus: false,
            accountsList: [],
            selectedRemoveAcc: null,
            paymentMethodList: null
        }
    },
    components: {
        DeletAccountModal,
        addAccountModal
    },
    mounted() {
        this.userAccountDetails();
    },
    methods: {
        onImageError(event) {
            event.target.src = require("@/assets/images/default-img.png") // or a public URL
        },
        copyPaymentData(event,catagory, accountData) {
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);      
            this.copiedText = accountData;
            this.$successToast(catagory + ' Copied');
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = ''; 
            });
            this.copiedText = null;
            event.target.style.color = '#0cddff';
            setTimeout(() => {
                event.target.style.color = '';
            }, 1000);
        },
        handleAddBankClick() {
            this.$helper.openModal('#addAccountModal');
        },
        async userAccountDetails(reconnectTry = 0) {
            try{
                let response = await getUserAccounts(this.walletConfig?.payment_method, reconnectTry)
                this.accountsList = response?.userAccounts
                this.paymentMethodList = response.paymentMethods;
                if (this.accountsList?.length > 0) {
                    this.selectedCardIndex = 0;
                    this.selectBankId = this.accountsList[0].client_account_id;
                }
            }
            catch(error){
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.[0]);
                }

            }
		},
        goToEdit(details) {
            this.$store.dispatch('setSelectedPayementAcc', details);
            this.$router.push({ 
                name: 'add-account', 
                params: { mode: 'edit' } // Passing 'edit' mode via query
            });
        },
        openDeleteModal() {
			this.$nextTick(() => {
                this.$helper.openModal("#deleteModalRef")
			});
		},
        removeAccountHere() {
			this.closeModal();
            this.userAccountDetails();
		},
		closeModal() {
            this.selectedRemoveAcc = null;
			const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
		},
    }
}
</script>
<style scoped>
.paymentAccount-nodata{
    font-size:15px;
    font-weight:600;
    background:linear-gradient(79.19deg, rgb(115, 113, 232) 0%, rgb(45, 42, 187) 100%);
    text-align: center;
}
</style>